/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetRecomendedOrdersDetailsQuery } from '../../models/get-recomended-orders-details-query';
import { GetRecomendedOrdersDetailsQueryResult } from '../../models/get-recomended-orders-details-query-result';

export interface ApiNurseryManagerOrderDetailsGetRecomendedOrdersDetailsPost$Plain$Params {
      body?: GetRecomendedOrdersDetailsQuery
}

export function apiNurseryManagerOrderDetailsGetRecomendedOrdersDetailsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerOrderDetailsGetRecomendedOrdersDetailsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetRecomendedOrdersDetailsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerOrderDetailsGetRecomendedOrdersDetailsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetRecomendedOrdersDetailsQueryResult>;
    })
  );
}

apiNurseryManagerOrderDetailsGetRecomendedOrdersDetailsPost$Plain.PATH = '/api/NurseryManager/OrderDetails/GetRecomendedOrdersDetails';
